import i18next, { InitOptions, Resource, ResourceLanguage } from 'i18next';
import dateFnsFormat from 'date-fns/format';
import nestedLinksPlugin from '@ecg-marktplaats/i18next-nested-links-parser-plugin';
import escapeTextForBrowser from './utils/escapeTextForBrowser';
import { I18nInstanceType } from './types';

export type InitProps = {
  lng: string; // Language token
  dateLocale: Object; // Date locale
  enableNestedLinksPlugin?: boolean;
  translations?: Resource; // key (namespace) value (translations object) object
  // @deprecated
  translation?: ResourceLanguage; // Translations object
};

/**
 * Returns i18next and date-fns bootsrapped with a specified language
 */

const init = ({
  lng,
  translation = {},
  translations = {},
  dateLocale,
  enableNestedLinksPlugin = false,
}: InitProps): I18nInstanceType => {
  const translationResources: ResourceLanguage = {
    translation,
    ...translations,
  };
  const newInstance = i18next.createInstance();

  const initObject: InitOptions = {
    lng,
    resources: {
      [lng]: translationResources,
    },
    interpolation: {
      escapeValue: false, // not needed for React!!
      formatSeparator: ',',
    },
    // key potentially can contain untrusted HTML which should be escaped if translation is not found
    parseMissingKeyHandler: (key: string, defaultValue?: string) => defaultValue || escapeTextForBrowser(key),
  };

  if (enableNestedLinksPlugin) {
    initObject.postProcess = 'nestedLinksParser';
    newInstance.use(nestedLinksPlugin).init(initObject);
  } else {
    newInstance.init(initObject);
  }

  return {
    t: newInstance.t.bind(newInstance),
    tExists: newInstance.exists.bind(newInstance),
    date: (date: Date | string | number, formatString?: string) =>
      dateFnsFormat(date, formatString, { locale: dateLocale }),
  };
};

export default {
  init,
};
